import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { TransferOfChargeProvider } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "presentation/view/components/styled/NbisTable.styled";
import TransferOfChargeMaintenance from "presentation/view/section/TransferOfCharge/TransferOfChargeMaintenance";

const TransferOfChargeContMain = () => {
    return <ANAInfoWrapper permission={Permission.TRANSFER_OF_CHARGE_MAINTENANCE}>
        <MessageBarWrapper>
            <TransferOfChargeProvider>
                <GridStyles />
                <TransferOfChargeMaintenance />
            </TransferOfChargeProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default TransferOfChargeContMain;